export default __webpack_public_path__ + "static/media/location.5d3a26de.svg";